"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var numeral = require("numeral");
var React = require("react");
var Clock = require("react-icons/lib/md/access-time");
var react_redux_1 = require("react-redux");
var tasks_1 = require("../redux/tasks");
var timer_1 = require("../redux/timer");
var Item_1 = require("./Item");
var LabeledDate_1 = require("./LabeledDate");
require("./style/Task.css");
var SubInformation_1 = require("./SubInformation");
var TaskDescription_1 = require("./TaskDescription");
var TaskTags_1 = require("./TaskTags");
var Task = /** @class */ (function (_super) {
    __extends(Task, _super);
    function Task() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderSpentSeconds = function () {
            var minutes = _this.props.spentSeconds / 60;
            var time = minutes < 60
                ? numeral(minutes).format("0") + " mins"
                : numeral(minutes / 60).format("0[.]0") + " hours";
            return (React.createElement(SubInformation_1.default, { key: "spentTime" },
                "Spent for: ",
                time));
        };
        return _this;
    }
    Task.prototype.render = function () {
        var _this = this;
        var _a = this.props, createdAt = _a.createdAt, detailed = _a.detailed, description = _a.description, setCurrentItem = _a.setCurrentItem, spentSeconds = _a.spentSeconds, tags = _a.tags, updatedAt = _a.updatedAt, updateCurrentItem = _a.updateCurrentItem;
        return (React.createElement(Item_1.default, __assign({}, this.props, { buttons: [
                React.createElement("div", { key: "turnOnTimer", className: "Task-button", onClick: function (event) {
                        _this.props.setCurrentItem(_this.task);
                        _this.props.toggleTimer();
                        event.stopPropagation();
                    } },
                    React.createElement(Clock, null)),
            ], details: [
                React.createElement(TaskTags_1.default, { key: "tags", tags: tags }),
                React.createElement(TaskDescription_1.default, { key: "description", text: description, onEdit: function (description) { return updateCurrentItem(__assign({}, _this.task, { description: description })); } }),
                this.renderSpentSeconds(),
                React.createElement(LabeledDate_1.default, { key: "createdAt", label: "Created on", value: createdAt }),
                React.createElement(LabeledDate_1.default, { key: "updatedAt", label: "Updated on", value: updatedAt }),
            ], item: this.task, onEditName: detailed && (function (name) { return updateCurrentItem(__assign({}, _this.task, { name: name })); }) })));
    };
    Object.defineProperty(Task.prototype, "task", {
        get: function () {
            var _a = this.props, createdAt = _a.createdAt, description = _a.description, id = _a.id, name = _a.name, spentSeconds = _a.spentSeconds, tags = _a.tags, updatedAt = _a.updatedAt;
            return { createdAt: createdAt, description: description, id: id, name: name, spentSeconds: spentSeconds, tags: tags, updatedAt: updatedAt };
        },
        enumerable: true,
        configurable: true
    });
    return Task;
}(React.Component));
exports.default = react_redux_1.connect(null, __assign({}, tasks_1.actionCreators, timer_1.actionCreators))(Task);



//////////////////
// WEBPACK FOOTER
// ./src/component/Task.tsx
// module id = 670
// module chunks = 0